import { Container, Typography, Box, Grid, Pagination } from "@mui/material";
import { React, useState, useEffect } from "react";
import CustomAppBar from "../../components/AppBar";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useTranslation } from "react-i18next";
import useSharedLocation from "../../hooks/useSharedLocation";
import LabTestIcon from "../../assets/Icon/LabTestIcon.png";
import LoaderContainer from "../../components/LoaderContainer";
import SoilTestLabCard from "../../components/Cards/SoilTestLabCard";
import api from "../../globals/axios";

const SoilTestLabs = () => {
  const { t } = useTranslation();
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    total_pages: 0,
    total_objects: 0,
  });

  // Get the location of the user
  const { location } = useSharedLocation();

  const fetchLabs = async (page = 1) => {
    try {
      const response = await api.get(
        `/soil-testing/soil-lab?lat=${location.latitude}&lon=${location.longitude}&page=${page}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching labs:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (!location?.staticLocation) {
      const getLabs = async () => {
        try {
          setLoading(true);
          const labsData = await fetchLabs(pagination.page);
          setLabs(labsData.results);
          setPagination((prev) => ({
            ...prev,
            total_pages: labsData.total_pages,
            total_objects: labsData.total_objects,
          }));
        } catch (error) {
          console.error("Failed to fetch labs:", error);
        } finally {
          setLoading(false);
        }
      };
      getLabs();
    }
  }, [location, pagination.page]);

  // Handle page change
  const handlePageChange = (event, value) => {
    setPagination((prev) => ({
      ...prev,
      page: value,
    }));
  };

  return (
    <>
      <CustomAppBar />
      <Container
        maxWidth="xs"
        sx={{
          height: "100vh",
        }}
      >
        <CustomTitle>{t("Soil Testing Labs")}</CustomTitle>
        {!location?.staticLocation ? (
          <>
            <LoaderContainer loading={loading} />
            <Grid container spacing={1} mt={1}>
              {labs.map((lab, index) => (
                <Grid item xs={12} key={index}>
                  <SoilTestLabCard key={index} lab={lab} />
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "2rem 0 6rem 0",
              }}
            >
              <Pagination
                count={pagination.total_pages}
                page={pagination.page}
                onChange={handlePageChange}
                color="primary"
                disabled={loading}
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "70%",
            }}
          >
            <Box sx={{ marginBottom: 3 }}>
              <img
                src={LabTestIcon}
                alt="My Crops Icon"
                style={{
                  width: "127px",
                  height: "127px",
                  marginBottom: "10px",
                }}
              />
            </Box>

            <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
              {t(
                "We need location permission to show Soil Testing Labs near you. If this doesn't work for you please visit, ....... to find the labs in your district."
              )}
            </Typography>
          </Box>
        )}
      </Container>
    </>
  );
};

export default SoilTestLabs;
